import { render, staticRenderFns } from "./ProposalCardVerticalResponsive.vue?vue&type=template&id=e86cb5da"
import script from "./ProposalCardVerticalResponsive.vue?vue&type=script&lang=js"
export * from "./ProposalCardVerticalResponsive.vue?vue&type=script&lang=js"
import style0 from "./ProposalCardVerticalResponsive.vue?vue&type=style&index=0&id=e86cb5da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports